export default __webpack_public_path__ + "static/media/Vecinos_Posts_EN.567fa082.png";